import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-support-close-dialog',
  templateUrl: './support-close-dialog.component.html',
  styleUrls: ['./support-close-dialog.component.scss']
})
export class SupportCloseDialogComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
